import React from "react";

const GeneExpressionDescription = () => {
  return (
    <div id="assy-creation-description">
      <h2>Gene Expression Assays Description</h2>

      <p>
        ddPCR Gene Expression Assays enable accurate quantification of small
        fold changes in gene expression, for e.g. expression differences that
        are 2-fold or lower, for detecting targets that may be present at low
        levels of abundance or samples that contain substances that can inhibit
        a PCR reaction. ddPCR Gene Expression Assays are available as probe or
        EvaGreen Assays. Protocols are provided for use in One-Step or Two-Step
        RT-ddPCR protocols.
      </p>
      <h3>Key Benefits</h3>

      <ul>
        <li>Enables detection of small fold changes in expression</li>
        <li>
          Choose from more than 60,000 gene expression assays for human, rat,
          and mouse
        </li>
        <li>Probe or EvaGreen® chemistry</li>
      </ul>
      <h3>Sample Data</h3>
      <br />
      <img
        src="http://www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-GENE-A.jpg"
        alt="6512-GENE-A"
        width="630"
        height="292"
        caption="false"
      />
      <br />
      <img
        src="http://www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-GENE-B.jpg"
        alt="6512-GENE-B"
        width="630"
        height="291"
        caption="false"
      />
      <br />
      <img
        src="http://www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-GENE-C.jpg"
        alt="6512-GENE-C"
        width="630"
        height="292"
        caption="false"
      />

      <p>
        <small>
          <strong>
            Robust PrimePCR gene expression assays used in ddPCR with EvaGreen
            provide precise quantification of 18 reference genes. A
          </strong>
          , 1-D fluorescence amplitude plot shows results of a two-step reverse
          transcription ddPCR reference assay panel run on human brain RNA. The
          black clusters on the plot represent the negative droplets and the
          blue clusters represent the droplets that are positive for the
          respective reference assay. <strong>B</strong>, concentration plot
          shows various gene concentrations of cDNA calculated as copies/µl on a
          log10 scale.
          <strong>C</strong>, calculated RNA concentrations in the original
          human brain RNA sample for each reference gene. All error bars are
          generated by QuantaSoft software and represent the 95% confidence
          interval.
        </small>
      </p>
      <h3>Packaging Options</h3>
      <p>
        ddPCR Gene Expression Probe Assays are available with a FAM or HEX
        fluorophore. Reference assays with the complimentary fluorophore are
        available. These assays have been designed for maximum specificity and
        transcript coverage. Assays are available for human, mouse, and rat.
        Each tube contains 18uM primers and 5uM probe.
      </p>
      <p>
        <span>
          ddPCR Gene Expression Assays (EvaGreen) consists of unlabeled PCR
          primer pairs for use with dye-based chemistry such as the ddPCR
          EvaGreen Supermix. Individual assays are provided as a 20x stock
          solution. Each tube contains 5uM each primer.
        </span>
      </p>
    </div>
  );
};

export default GeneExpressionDescription;
